export default "__VITE_ASSET__C16WHC5h__"